module.exports = __webpack_public_path__ + "static/img/194_TO8_2091.065982c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/194_TO8_2091.jpg
// module id = cBPC
// module chunks = 0